export const LastSelectedProjectAndDeploymentKey = "v1/last-selected-project-and-deployment";
export const LOCAL_STORAGE_KEY_ACCEPTED_AKI_TERMS = "v1/accepted-ask-aki-terms";
export const DockerDesktopOriginFlagKey = "v1/docker-desktop-origin-flag";
